module.exports = __webpack_public_path__ + "img/auth-mobile-image.fa7efd5c.jpg";